export const mapRecommendedDepositAmount = (n?: number): number => {
  if (!n) {
    return 0;
  }

  return Math.ceil(n);
};
